module.exports = __webpack_public_path__ + "static/img/dMRI3.f3f97f0c.png";